export var ErrorName;
(function (ErrorName) {
    ErrorName["RPCError"] = "RPCError";
    ErrorName["ProviderError"] = "ProviderError";
    ErrorName["ServerError"] = "ServerError";
    ErrorName["TransactionError"] = "TransactionError";
    ErrorName["ValidationError"] = "ValidationError";
    ErrorName["BalanceError"] = "BalanceError";
    ErrorName["NotFoundError"] = "NotFoundError";
    ErrorName["UnknownError"] = "UnknownError";
    ErrorName["SlippageError"] = "SlippageError";
    ErrorName["HTTPError"] = "HTTPError";
})(ErrorName || (ErrorName = {}));
export var LiFiErrorCode;
(function (LiFiErrorCode) {
    LiFiErrorCode[LiFiErrorCode["InternalError"] = 1000] = "InternalError";
    LiFiErrorCode[LiFiErrorCode["ValidationError"] = 1001] = "ValidationError";
    LiFiErrorCode[LiFiErrorCode["TransactionUnderpriced"] = 1002] = "TransactionUnderpriced";
    LiFiErrorCode[LiFiErrorCode["TransactionFailed"] = 1003] = "TransactionFailed";
    LiFiErrorCode[LiFiErrorCode["Timeout"] = 1004] = "Timeout";
    LiFiErrorCode[LiFiErrorCode["ProviderUnavailable"] = 1005] = "ProviderUnavailable";
    LiFiErrorCode[LiFiErrorCode["NotFound"] = 1006] = "NotFound";
    LiFiErrorCode[LiFiErrorCode["ChainSwitchError"] = 1007] = "ChainSwitchError";
    LiFiErrorCode[LiFiErrorCode["TransactionUnprepared"] = 1008] = "TransactionUnprepared";
    LiFiErrorCode[LiFiErrorCode["GasLimitError"] = 1009] = "GasLimitError";
    LiFiErrorCode[LiFiErrorCode["TransactionCanceled"] = 1010] = "TransactionCanceled";
    LiFiErrorCode[LiFiErrorCode["SlippageError"] = 1011] = "SlippageError";
    LiFiErrorCode[LiFiErrorCode["SignatureRejected"] = 1012] = "SignatureRejected";
    LiFiErrorCode[LiFiErrorCode["BalanceError"] = 1013] = "BalanceError";
    LiFiErrorCode[LiFiErrorCode["AllowanceRequired"] = 1014] = "AllowanceRequired";
    LiFiErrorCode[LiFiErrorCode["InsufficientFunds"] = 1015] = "InsufficientFunds";
    LiFiErrorCode[LiFiErrorCode["ExchangeRateUpdateCanceled"] = 1016] = "ExchangeRateUpdateCanceled";
    LiFiErrorCode[LiFiErrorCode["WalletChangedDuringExecution"] = 1017] = "WalletChangedDuringExecution";
    LiFiErrorCode[LiFiErrorCode["TransactionExpired"] = 1018] = "TransactionExpired";
    LiFiErrorCode[LiFiErrorCode["TransactionSimulationFailed"] = 1019] = "TransactionSimulationFailed";
    LiFiErrorCode[LiFiErrorCode["TransactionConflict"] = 1020] = "TransactionConflict";
    LiFiErrorCode[LiFiErrorCode["TransactionNotFound"] = 1021] = "TransactionNotFound";
    LiFiErrorCode[LiFiErrorCode["TransactionRejected"] = 1022] = "TransactionRejected";
    LiFiErrorCode[LiFiErrorCode["RateLimitExceeded"] = 1023] = "RateLimitExceeded";
    LiFiErrorCode[LiFiErrorCode["ThirdPartyError"] = 1024] = "ThirdPartyError";
    LiFiErrorCode[LiFiErrorCode["InsufficientGas"] = 1025] = "InsufficientGas";
})(LiFiErrorCode || (LiFiErrorCode = {}));
export var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["UnknownError"] = "Unknown error occurred.";
    ErrorMessage["SlippageError"] = "The slippage is larger than the defined threshold. Please request a new route to get a fresh quote.";
    ErrorMessage["GasLimitLow"] = "Gas limit is too low.";
    ErrorMessage["TransactionUnderpriced"] = "Transaction is underpriced.";
    ErrorMessage["TransactionReverted"] = "Transaction was reverted.";
})(ErrorMessage || (ErrorMessage = {}));
//# sourceMappingURL=constants.js.map